// extracted by mini-css-extract-plugin
export default {"eventDetailsContent":"EventsDetails_eventDetailsContent__nytiS","eventInfo":"EventsDetails_eventInfo__OwRED","aboutThisEvent":"EventsDetails_aboutThisEvent__9tw2n"};